import React from "react";
import * as PropTypes from "prop-types";
import moment from "moment/moment";
import {when} from "mobx";
import unapprovedPostsStore from "../../../../modules/social/approvePosts/UnapprovedPostsStore"
import EntityTaskStore from "../../../../modules/workflow/popovers/EntityTaskStore";
import userResolver from "../../../../services/users/UserResolver";
import sessionStore from '../../../../services/session/SessionStore';
import {NameChip} from "../../../../components/index";
import {UserOrLoading} from "../../../../services/users/components/UserOrLoading";
import {MediaAttachment} from "../../../../components/uploadgallery/MediaAttachment";
import {SchedulePageSummary} from "./SchedulePageSummary";
import {PublishedResponseStatus} from "./PublishedResponseStatus";

import {observer} from "mobx-react"

export const PublishedResponse = observer(class PublishedResponse extends React.Component {

  static propTypes = {
    item: PropTypes.any.isRequired,
    style: PropTypes.any,
    hideNotes: PropTypes.bool
  };

  static defaultProps = {
    hideNotes: false
  };

  state = {
    saving: false
  };

  addNote = (event) => {
    let formData = new FormData(event.target);
    this.setState({saving: true});
    unapprovedPostsStore.saveNote(this.props.item, {text: formData.get('text')});
    event.target.reset();
    event.stopPropagation();
    event.preventDefault();

    const taskStore = new EntityTaskStore();
    if (this.props.item.inReplyTo) {
      taskStore.loadTasksByEntityId(this.props.item.inReplyTo) // need to figure out where we're storing the ID for the scheduled ones
    }
    when(() => !taskStore.loading, () => {
      const task = taskStore.tasks[0];
      if (task) {
        taskStore.addComment(task, {body: formData.get("text")}) // this feels like we're just asking for trouble
      }
    })
  };

  render() {
    const {item, style, hideNotes} = this.props
    return <div className="quote clearfix publishing-responses" style={{...style, marginBottom: '5px'}}>
      <PublishedResponseStatus item={item} className={"pull-right"}/>
      <SchedulePageSummary schedule={item} style={{display: 'inline-block'}}/>

      {
        item.publishType === 'Repost' ?
          <div><i>[Repost]</i></div> :
          <div>{item.details && item.details.text}</div>
      }
      {
        item.details && item.details.attachment ?
          <MediaAttachment style={{marginTop: '5px'}}
                           src={item.details.attachment}
                           imageStyle={{maxWidth: '200px', maxHeight: '200px'}}/> :
          undefined
      }

      { !hideNotes &&
        <div className="post-notes-container">
          <label>Notes</label>
          {item.notes.map(note => {
            let author = userResolver.fetchOne(note.author)

            return <div className="d-flex note" key={note._id.$oid}>
              <div className="note-author">
                <NameChip name={author.user.username} />
              </div>
              <div className="note-text">
                <div className="author-details">
                  <UserOrLoading className="username" justName={true} user={userResolver.fetchOne(note.author)}/>
                  <span className="separator">&bull;</span>
                  <span className="note-date">{moment(note.createdAt).fromNow()}</span>
                </div>
                {note.text}
              </div>
            </div>
          })}

          <form name="add-note-form" className="form-inline" onSubmit={this.addNote}>
            <NameChip name={sessionStore.user.username} className="mr-1"/>
            <input type="text" className="form-control" name="text" required />
            <button type="submit" className="btn btn-secondary btn-sm ml-1">Add Note</button>
          </form>
        </div>
      }
    </div>
  }
});
